<template>
    <div>
        <vue-plyr ref="plyr" :key="id">
            <video playsinline webkit-playsinline ref="player" id="player">
                <source :src="getResource" :type="getType">
            </video>
        </vue-plyr>
    </div>
</template>


<script>
export default {
    props: ['file_url', 'id'],

    computed: {
        player () { return this.$refs.plyr.player },

        getType() {
            return this.$mime.lookup(this.file_url.split('?')[0])
        },

        getResource() {
            return this.file_url
        }
    },

    methods: {
        enterfullscreen(e) {
            this.$emit('display', 'none')
        },

        exitfullscreen(e) {
            this.$emit('display', 'flex')
        },
    },

    mounted () {
        this.player.on('enterfullscreen', (val) => this.enterfullscreen(val))
        this.player.on('exitfullscreen', (val) => this.exitfullscreen(val))
    },
}
</script>

<style lang="stylus" scoped>
</style>
